<template>
  <b-modal
    id="client-cancel-booking-modal"
    :ok-title="trans('close')"
    ok-variant="secondary"
    :ok-disabled="busy"
    ok-only
    @shown="onShown"
  >
    <template v-slot:modal-title>
      {{ trans('booking') }}
      <small v-if="!!booking" class="text-muted">
        #{{ booking.id }}
      </small>
    </template>

    <p v-if="!!booking">
      {{ booking.name }}
    </p>

    <p v-if="!!rule && !!rule.message">
      <span v-html="rule.message"></span>
    </p>

    <p v-if="allowed">
      <b-button variant="danger" @click="onClickCancelBooking">
        {{ trans('cancel_booking') }}
      </b-button>
    </p>

    <p v-if="!!rule && !rule.allowed" class="text-danger">
      <span v-html="rule.error"></span>
    </p>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      organization: Object,
      booking: Object,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        rule: null,
      }
    },
    computed: {
      allowed() {
        return !!this.booking && !!this.rule && this.rule.allowed
      },
    },
    methods: {
      onShown() {
        this.fetchRule()
      },
      fetchRule() {
        this.busy = true
        this.error = null
        this.rule = null

        let url = `/org/${this.organization.id}/client/bookings/${this.booking.id}/cancellation_rule`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.rule = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onClickCancelBooking() {
        this.$bvModal.msgBoxConfirm(trans('cancel_booking_confirmation'), {
          title: trans('cancel_booking'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: trans('yes'),
          cancelTitle: trans('no'),
        })
        .then(value => {
          if (value) {
            this.busy = true
            this.error = null

            let url = `/org/${this.organization.id}/client/bookings/${this.booking.id}`
            axios.delete(url)
            .then(response => {
              this.busy = false
              this.$emit('cancelled', this.booking)
              _.toastSuccess(this, response.data.message)
              this.$bvModal.hide('client-cancel-booking-modal')
            })
            .catch(error => {
              this.busy = false
              this.error = _.errorFromAjax(error)
            })
          }
        })
      },
    }
  }
</script>